import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-dynamic-video', (editor, opts) => {
  const config = {
    blocks: [
      'dynamicVideo',
    ],
    name: 'dynamicVideo',
    stylePrefix: 'gjs-',
    defText: 'Sample',
    category: 'Base de Datos',
    labelDynVideo: 'Video Dinamico',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
